<template>
    <div class="collapsible-details-placeholder">
        <Placeholder class='details-placeholder'/>
        <Placeholder class='delivery-returns-placeholder'/>
    </div>
</template>

<script>
import Placeholder from '@/ecom/components/loading/Placeholder.vue';

export default {
    components: {Placeholder}    
}
</script>

<style lang="scss" scoped>
.collapsible-details-placeholder{
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    gap: 25px;
}
.details-placeholder{
    width: 22%; 
    height: 24px;
}
.delivery-returns-placeholder{
    width: 35%; 
    height: 24px;
}
</style>